
import React from 'react';
import { DollarSign, Sparkles, TrendingUp, Calculator } from "lucide-react";
import { useIsMobile } from '@/hooks/use-mobile';

interface PageHeaderProps {
  crystalBallMode: boolean;
}

export const PageHeader = ({ crystalBallMode }: PageHeaderProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="text-center mb-8 sm:mb-16 relative">
      {/* Animated background gradient */}
      <div className="absolute inset-0 -z-10 hero-gradient blur-3xl opacity-20 animate-gradient-shift"></div>
      
      <div className="relative mb-6 sm:mb-10">
        {/* Decorative line with pulse effect */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-full max-w-md h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent animate-pulse" />
        </div>
        
        {/* Main icon with enhanced animation */}
        <div className="relative z-10 inline-flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gradient-to-br from-primary/20 to-secondary/20 backdrop-blur-sm border border-primary/20 animate-scale-in floating-element">
          {crystalBallMode ? (
            <Sparkles className="w-10 h-10 sm:w-12 sm:h-12 text-primary glow-effect" />
          ) : (
            <Calculator className="w-10 h-10 sm:w-12 sm:h-12 text-primary glow-effect" />
          )}
        </div>
        
        {/* Secondary decorative icons */}
        <DollarSign className="absolute -top-2 -right-2 w-6 h-6 text-accent-cyan animate-bounce" style={{ animationDelay: '0.5s' }} />
        <TrendingUp className="absolute -bottom-2 -left-2 w-6 h-6 text-accent-orange animate-bounce" style={{ animationDelay: '1s' }} />
      </div>
      
      <div className="space-y-4 animate-fade-in">
        <h1 className="text-3xl sm:text-5xl font-bold gradient-text-cosmic">
          {crystalBallMode ? "Rate Crystal Ball" : "The Rate Whisperer"}
        </h1>
        <p className="text-lg sm:text-xl text-text-secondary max-w-2xl mx-auto leading-relaxed">
          {crystalBallMode 
            ? "✨ Peer into your financial future and calculate earnings based on your desired rate" 
            : "💡 Discover your true worth and calculate the ideal freelance rate for your lifestyle"}
        </p>
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-primary/10 to-secondary/10 border border-primary/20">
          <span className="text-sm text-text-accent font-medium">Powered by Real Market Data</span>
        </div>
      </div>
    </div>
  );
};
